<template>
  <div>
    <img alt="Leadtributor logo" src="../assets/leadtributor-logo-text.png" width="500">
    <v-row>
      <v-col cols="12">
        <CardComponent :show-title="false">
          <template v-slot:title>Demo content.</template>
          <v-row v-for="n in 2" :key="n">
            <v-col cols="12">
              <TextFieldCustom>
                <template v-slot:prepend>
                  Einzeiliges Formular-Feld {{ n }}
                </template>
              </TextFieldCustom>
            </v-col>
          </v-row>
          <v-row v-for="n in 2" :key="n + 2">
            <v-col cols="12">
              <TextAreaCustom>
                <template v-slot:prepend>Mehrzeiliges Formular-Feld {{ n }}</template>
              </TextAreaCustom>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <NumberTextField v-model="numberTExtFieldModel">
                <template v-slot:prepend>Number Textfield</template>
              </NumberTextField>
            </v-col>
          </v-row>
          <v-row></v-row>
          <v-row>
            <v-col cols="12">
              <EditorComponent v-model="editorComponentModel"/>
            </v-col>
          </v-row>
        </CardComponent>
        <CardComponent>
          <template v-slot:title>2nd CardComponent with title</template>
          <v-card-text>
            Weit hinten, hinter den Wortbergen, fern der Länder Vokalien und Konsonantien leben die Blindtexte.
            Abgeschieden wohnen sie in Buchstabhausen an der Küste des Semantik, eines großen Sprachozeans.
            Ein kleines Bächlein namens Duden fließt durch ihren Ort und versorgt sie mit den nötigen Regelialien. Es
            ist ein paradiesmatisches Land, in dem einem gebratene Satzteile in den Mund fliegen.
          </v-card-text>
        </CardComponent>
        <CardComponent>
          <template v-slot:title>Editor Card Component</template>
          <EditorCardComponent v-model="editorCardComponentModel"/>
        </CardComponent>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="example-height">
        <FieldListComponent title="Kontakt" v-model="editorCardComponentModel"/>
      </v-col>
    </v-row>
    <pre>
      <h2>editorCardComponentModel</h2>
    <code>{{ JSON.stringify(editorCardComponentModel, null, "\t") }}</code>
    </pre>
    {{ editorComponentModel }}
  </div>
</template>

<script>
import CardComponent from "@/components/form/CardComponent";
import TextFieldCustom from "@/components/form/TextFieldCustom";
import TextAreaCustom from "@/components/form/TextAreaCustom";
import NumberTextField from "@/components/form/NumberTextField";
import {ref, reactive} from "@vue/composition-api";
import EditorComponent from "@/components/form/EditorComponent";
import EditorCardComponent from "@/components/form/EditorCardComponent";
import FieldListComponent from "@/components/form/FieldListComponent";

export default {
  name: "CardView",
  components: {
    FieldListComponent,
    EditorCardComponent,
    EditorComponent,
    NumberTextField,
    TextAreaCustom,
    TextFieldCustom,
    CardComponent
  },
  setup() {
    const numberTExtFieldModel = ref('')
    const editorComponentModel = reactive({
      inputValue: '',
      type: '',
      fieldName: '',
      edit: true
    })

    const editorCardComponentModel = reactive([
      {inputValue: 'Unbekannte Firma', type: 'TextFieldCustom', fieldName: 'Firma', edit: false},
      {
        inputValue: 'Zauber Straße 23\nMünster 48143\nDeutschland',
        type: 'TextAreaCustom',
        fieldName: 'Adresse',
        edit: false
      },
      {inputValue: 'Unbekannter Name', type: 'TextFieldCustom', fieldName: 'Name', edit: false},
      {inputValue: '234', type: 'NumberTextField', fieldName: 'Number', edit: false},
    ])

    return {numberTExtFieldModel, editorComponentModel, editorCardComponentModel}
  }
}
</script>

<style scoped>
.example-height {
  max-height: 400px;
}
</style>
